<template>
    <div>
        <div class="">
            <div class="faq-wrap">
                <div class="card-box"
                    style="padding-left: 20px;padding-right: 20px;padding-bottom: 10px;padding-top: 20px;">
                    <div class="card-header">
                        <div class="clearfix">
                            <div class="pull-left">
                                <h4 class="text-black h4">Cadastro de telas institucional</h4>
                            </div>
                        </div>
                    </div>
                    <v-form>
                        <v-container>
                            <v-row>
                                <v-col cols="12" md="4" v-show="false">
                                    <v-text-field v-model="CadastroTela.ctiId" label="Id" variant="underlined"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4" v-if="GrupoTelas!=''">
                                    <v-select v-model="CadastroTela.gtiId" label="Grupo Telas" :items="GrupoTelas"
                                        item-title="gtiNome" item-value="gtiId" variant="underlined">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" md="8">
                                    <v-text-field v-model="CadastroTela.ctiNome" :rules="nameRules" :counter="200"
                                        label="Nome Tela" variant="underlined" required></v-text-field>
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-text-field v-model="CadastroTela.ctiOrdem" label="Ordem" type="number"
                                        variant="underlined"></v-text-field>
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-select v-model="CadastroTela.ctiVisivel" label="Visível" :items="Status"
                                        item-title="nome" item-value="ctiVisivel" variant="underlined">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="CadastroTela.ctiUrl" label="Nome sem espaços"
                                        variant="underlined"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                    <form>
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <button type="button" @click="Limpar()" class="btn btn-link">
                                    Cancelar
                                </button>
                                <button v-if="CadastroTela.ctiId != 0" type="button" class="btn btn-success" @click="Put()">
                                    Alterar
                                </button>
                                <button v-else type="button" class="btn btn-success" @click="Add()">
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="">
            <div class="faq-wrap">
                <div class="card-box" style="padding-left: 20px;padding-right: 20px;padding-bottom: 10px;margin-top: 20px;">
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="searchValue" label="Pesquisa" variant="underlined"
                                    required></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                    <easy-data-table :headers="headers" :items="preprocessData(CadastroTelas)" v-model="itemsSelected" alternating
                        theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                        body-text-direction="center" rows-per-page-message="Linhas por pagina" :search-value="searchValue">
                        <template #item-ctiVisivel="item">
                            <span>{{ item.ctiVisivel ? 'Sim' : 'Não' }}</span>
                        </template>
                        <template #item-urlApi="item">
                            <span>{{ urlApi + item.ctiId + '/' + item.ctiUrl }}</span>
                        </template>
                        <template #item-actions="item">
                            <v-btn icon @click="EditGrid(item)" style="margin-right: 10px;" variant="text">
                                <v-icon>mdi-file-edit-outline</v-icon>
                                <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                            </v-btn>

                            <v-btn icon @click="DeleteGrid(item)" variant="text">
                                <v-icon>mdi-delete-forever-outline</v-icon>
                                <v-tooltip activator="parent" location="top">Excluir</v-tooltip>
                            </v-btn>
                        </template>
                    </easy-data-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
export default {
    name: 'CadastroTelasInstitucionalView',
    components: {
        EasyDataTable
    },
    data: () => ({
        CadastroTela: {
            ctiId: 0,
            ctiNome: '',
            ctiOrdem: '',
            ctiVisivel: '',
            ctiUrl: '',
            gtiId:''
        },
        CadastroTelas: [],
        GrupoTelas:[],
        selectedVisivel: null,
        selectedGrupo: null,
        Status: [{ nome: "Sim", ctiVisivel: true }, { nome: "Não", ctiVisivel: false }],
        nameRules: [
            value => {
                if (value?.length <= 200) return true
                return 'Nome pode conter até 200 caracteres.'
            },
        ],

        headers: [
            { text: "Id", value: "ctiId", sortable: true, },
            { text: "Grupo", value: 'admGrupoTelasInst.gtiNome', sortable: true, },
            { text: "Tela", value: "ctiNome", sortable: true, },
            { text: "Ordem", value: "ctiOrdem", sortable: true,},
            { text: "Visivel", value: "ctiVisivel", sortable: true, },
            { text: "Nome", value: "ctiUrl" },
            { text: "Link", value: "urlApi" },
            { text: 'Ações', value: 'actions' }
        ],
        itemsSelected: [],
        selectedItem: null,
        searchValue: '',
        urlApi: '/institucional/',
    }),
    methods: {
        preprocessData(data) {
            return data.map(item => {
            return {
                ...item,
                ctiOrdem: parseInt(item.ctiOrdem),
            };
            });
        },
        Limpar() {
            this.CadastroTela.ctiId = 0;
            this.CadastroTela.ctiNome = '';
            this.CadastroTela.ctiOrdem = '';
            this.CadastroTela.ctiVisivel = '';
            this.CadastroTela.ctiUrl = '';
            this.CadastroTela.gtiId = '';
            this.selectedVisivel = '';
            this.selectedGrupo = null;
            this.Get();
        },
        Add() {
            if (this.CadastroTela.ctiNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.CadastroTela.ctiUrl == ''){
                this.$mensagemAviso("Url Obrigatória.")
            }
            else if (this.CadastroTela.ctiOrdem === ''){
                this.$mensagemAviso("Ordem Obrigatória.")
            }
            else if (this.CadastroTela.ctiVisivel === ''){
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else if (this.CadastroTela.gtiId == null || this.CadastroTela.gtiId == ''){
                this.$mensagemAviso("Grupo Obrigatório.")
            }
            else {
                this.CadastroTela.ctiOrdem = parseInt(this.CadastroTela.ctiOrdem)
                this.CadastroTela.admGrupoTelasInst = { gtiId: this.CadastroTela.gtiId};
                axios.post(`Process/AdmCadastroTelasInst/Add`, this.CadastroTela)
                    .then(response => {
                        if (response.data > 0) {
                            this.$mensagemAvisoSucesso("Registro Incluído.")
                            this.Get();
                            this.Limpar();
                        }
                    });
            }
        },
        Put() {
            if (this.CadastroTela.ctiNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.CadastroTela.ctiUrl == ''){
                this.$mensagemAviso("Url Obrigatória.")
            }
            else if (this.CadastroTela.ctiOrdem === ''){
                this.$mensagemAviso("Ordem Obrigatória.")
            }
            else if (this.CadastroTela.ctiVisivel === ''){
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else if (this.CadastroTela.gtiId == null || this.CadastroTela.gtiId == ''){
                this.$mensagemAviso("Grupo Obrigatório.")
            }
            else {
                this.CadastroTela.ctiOrdem = parseInt(this.CadastroTela.ctiOrdem)
                this.CadastroTela.admGrupoTelasInst = { gtiId: this.CadastroTela.gtiId};
               axios.put(`Process/AdmCadastroTelasInst/Update`, this.CadastroTela)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                            this.Limpar();
                        }
                    });
            }
        },
        EditGrid(item) {
            // Lógica para editar o item
            this.CadastroTela = item;
            this.CadastroTela.gtiId = item.admGrupoTelasInst.gtiId
            this.$scrollToTop();
        },
        DeleteGrid(item) {

            this.$mensagemConfirma('Tem certeza que deseja excluir?')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
                const param1 = item.ctiId;
                axios.delete(`/Process/AdmCadastroTelasInst/Delete/${param1}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Registro Excluido.")
                        this.Get();
                        this.Limpar();
                    }
                });
            }
            });
        },
        Get() {
            axios.get(`Process/AdmCadastroTelasInst/GetAll`)
                .then(response => {
                    this.CadastroTelas = response.data;
                });
        }
    },
    created() {
        this.Get();

        axios.get(`/Process/AdmGrupoTelasInst/GetAll`)
                .then(response => {
                    this.GrupoTelas = response.data.filter(x => x.gtiVisivel).sort((a, b) => {
                                                                                            const nomeA = a.gtiNome || ""; 
                                                                                            const nomeB = b.gtiNome || ""; 
                                                                                            return nomeA.localeCompare(nomeB);
                                                                                            });
                });

    },
}
</script>

<style></style>
